export default __webpack_public_path__ + "static/media/curve.8dbe9f6b.svg";